/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import Payment, { SdkMessage, MessageType, ClientSdkInstance } from '@solidgate/react-sdk'
import { createSolidGatePaymentIntent } from '@/helpers/solidGateHelpers'
import { PaymentPlan } from '@/types/types'
import { cn } from '@/lib/utils'
import {
  clickPurchaseButton,
  trackLoadedApplePay,
  trackPayment,
  trackPaymentErrors,
} from '@/helpers/facebookPixelEvents'

interface PaymentFormInterface {
  plan: PaymentPlan
  email: string
  onSuccess: (val: boolean) => void
  handleLoading: (val: boolean) => void
  version?: string
  paymentImage?: string
}

export const PaymentFormV2 = (props: PaymentFormInterface) => {
  const [merchantData, setMerchantData] = useState()
  const [isFailedPayment, setIsFailedPayment] = useState(false)
  const [paymentError, setPaymentError] = useState('')
  const [paymentType, setPaymentType] = useState('applePay')
  const theme = localStorage.getItem('data-theme') ?? 'dark'
  const trafficSource = localStorage.getItem('trafficSource') ?? ''
  const mainColor = theme === 'dark' ? '#fff' : '#000'
  const appleContainerRef = useRef(null)

  const handleCreatePaymentIntent = () => {
    createSolidGatePaymentIntent({
      email: props.email,
      productId: props.plan.solidGateProductID ?? '',
      failUrl: `${window.location.origin}/fail-payment`,
      trafficSource,
    }).then((res) => {
      setMerchantData(res)
      trackPayment('SolidGateInit', 'true')
      setIsFailedPayment(false)
    })
  }

  useEffect(() => {
    handleCreatePaymentIntent()
  }, [props.plan])

  useEffect(() => {
    trackLoadedApplePay()
  }, [])

  useEffect(() => {
    if (!isFailedPayment) {
      handleCreatePaymentIntent()
    }
  }, [isFailedPayment])

  const handleOnError = (e: SdkMessage[MessageType.Error]) => {
    trackPaymentErrors('SolidGateError', e)
  }

  const handleOnFail = (e: SdkMessage[MessageType.Fail]) => {
    setIsFailedPayment(true)
    trackPaymentErrors('SolidGateFail', e.message)
    setPaymentError(e.message ?? '')
  }

  const handleOnMounted = (e: SdkMessage[MessageType.Mounted]) => {
    setTimeout(() => {
      props.handleLoading(false)
    }, 500)
  }

  const handleOrderStatus = (e: SdkMessage[MessageType.OrderStatus]) => {}

  const handleOnResize = (e: SdkMessage[MessageType.Resize]) => {}

  const handleOnSuccess = (e: SdkMessage[MessageType.Success]) => {
    props.onSuccess(true)
  }

  const handleOnSubmit = (e: SdkMessage[MessageType.Submit]) => {
    clickPurchaseButton('card')
  }

  const handleOnInteraction = (e: SdkMessage[MessageType.Interaction]) => {}

  const handleOnVerify = (e: SdkMessage[MessageType.Verify]) => {}

  const handleOnRedirectMessage = (e: SdkMessage[MessageType.Redirect]) => {}

  const handleOnCustomStylesAppended = (e: SdkMessage[MessageType.CustomStylesAppended]) => {}

  const handleCard = (e: SdkMessage[MessageType.Card]) => {}

  const handleOnReadyPaymentInstance = (form: ClientSdkInstance) => {}

  return (
    <>
      {props.version === 'alternative'
        ? merchantData && (
            <div className={cn({ 'payment-response': isFailedPayment }, 'solid-gate-form mt-3')}>
              <div
                className={cn('border rounded-[16px] border-[#101A363D] alternative-apple-payment', {
                  'bg-black border-[#349760] border-2': paymentType === 'applePay',
                })}
              >
                <button
                  className={cn(
                    'flex min-h-[72px] font-medium text-[#101A36] items-center rounded-[16px] w-full py-6 px-6 bg-bg dark:bg-[#323232]',
                    { 'bg-transparent dark:bg-transparent': paymentType === 'applePay' },
                  )}
                  onClick={() => setPaymentType('applePay')}
                >
                  <span className="w-5 relative mr-4 min-w-[22px] block h-[22px] bg-black dark:bg-transparent rounded-full border-[#101A363D] border-2">
                    <svg
                      className={cn(
                        'absolute top-[-2px] left-[-2px] w-[calc(100%+4px)] opacity-0 h-[calc(100%+4px)]',
                        { 'opacity-1': paymentType === 'applePay' },
                      )}
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="1"
                        y="1"
                        width="20"
                        height="20"
                        rx="10"
                        stroke="#349760"
                        stroke-width="2"
                      />
                      <circle cx="11" cy="11" r="7" fill="#349760" />
                    </svg>
                  </span>

                  <span className="text-[16px] leading-[1.5] font-semibold block mr-1">
                    One-click payment
                  </span>

                  <span className="ml-auto block">
                    <svg
                      width="40"
                      height="28"
                      viewBox="0 0 40 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.27278 9.7305C8.87283 9.78218 9.47288 9.42047 9.84792 8.96188C10.2167 8.49037 10.4605 7.85739 10.398 7.21149C9.86667 7.23732 9.21036 7.57319 8.83533 8.0447C8.49155 8.45162 8.19777 9.11044 8.27278 9.7305ZM15.4113 18.0497V7.98014H19.0679C20.9556 7.98014 22.2744 9.32361 22.2744 11.2872C22.2744 13.2507 20.9306 14.6071 19.0179 14.6071H16.924V18.0497H15.4113ZM10.3916 9.85327C9.86299 9.82183 9.38064 10.0175 8.99102 10.1756C8.7403 10.2774 8.52798 10.3635 8.36645 10.3635C8.18518 10.3635 7.9641 10.2728 7.71587 10.1709C7.39061 10.0373 7.01875 9.88469 6.62879 9.89202C5.73496 9.90494 4.90364 10.4281 4.44735 11.2613C3.50977 12.9278 4.20358 15.3951 5.10991 16.7515C5.5537 17.4232 6.085 18.1596 6.78506 18.1337C7.09304 18.1217 7.31459 18.0246 7.54387 17.924C7.80783 17.8083 8.08205 17.6881 8.51021 17.6881C8.92353 17.6881 9.18575 17.8052 9.43747 17.9176C9.67681 18.0245 9.90666 18.1271 10.2479 18.1208C10.9729 18.1079 11.4292 17.4491 11.873 16.7773C12.3519 16.0564 12.5624 15.3528 12.5943 15.246L12.5981 15.2336C12.5976 15.2332 12.5955 15.232 12.5917 15.2302C12.589 15.2289 12.5854 15.2272 12.581 15.2251L12.581 15.2251C12.4209 15.1494 11.1972 14.5705 11.1855 13.0182C11.1737 11.7153 12.156 11.0551 12.3107 10.9512C12.3201 10.9449 12.3264 10.9406 12.3293 10.9384C11.7042 9.98245 10.7292 9.8791 10.3916 9.85327ZM25.0366 18.1272C25.9867 18.1272 26.868 17.6299 27.268 16.8419H27.2993V18.0497H28.6994V13.0375C28.6994 11.5843 27.5743 10.6477 25.8429 10.6477C24.2365 10.6477 23.0489 11.5972 23.0051 12.9019H24.3678C24.4803 12.2818 25.0366 11.8749 25.7991 11.8749C26.7242 11.8749 27.243 12.3206 27.243 13.1409V13.6964L25.3554 13.8126C23.5989 13.9224 22.6489 14.6652 22.6489 15.957C22.6489 17.2617 23.6302 18.1272 25.0366 18.1272ZM25.4428 16.9323C24.6365 16.9323 24.1239 16.5319 24.1239 15.9183C24.1239 15.2853 24.6177 14.9171 25.5616 14.859L27.243 14.7492V15.3176C27.243 16.2606 26.4679 16.9323 25.4428 16.9323ZM33.3428 18.4437C32.7365 20.207 32.0427 20.7884 30.5676 20.7884C30.4551 20.7884 30.08 20.7754 29.9925 20.7496V19.5418C30.0863 19.5547 30.3176 19.5676 30.4363 19.5676C31.1051 19.5676 31.4802 19.2769 31.7114 18.5212L31.849 18.0756L29.2862 10.7446H30.8676L32.649 16.6933H32.6803L34.4617 10.7446H35.9993L33.3428 18.4437ZM16.9229 9.2977H18.6668C19.9794 9.2977 20.7295 10.0211 20.7295 11.2935C20.7295 12.566 19.9794 13.2958 18.6606 13.2958H16.9229V9.2977Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </button>
                <div className={cn('p-6 pt-0 hidden', { block: paymentType === 'applePay' })}>
                  <div ref={appleContainerRef} className="h-[48px]" />
                </div>
              </div>

              <div
                className={cn('border rounded-[16px] border-[#101A363D] mt-3', {
                  'bg-black border-[#349760] border-2': paymentType === 'card',
                })}
              >
                <button
                  className={cn(
                    'flex min-h-[72px] font-medium text-[#8B8B8C] items-center rounded-[16px] w-full py-2 px-4 bg-bg dark:bg-[#323232]',
                    { 'bg-transparent dark:bg-transparent text-white': paymentType === 'card' },
                  )}
                  onClick={() => setPaymentType('card')}
                >
                  <span className="w-5 relative mr-4 min-w-[22px] block h-[22px] bg-black dark:bg-transparent rounded-full border-[#101A363D] border-2">
                    <svg
                      className={cn(
                        'absolute top-[-2px] left-[-2px] w-[calc(100%+4px)] opacity-0 h-[calc(100%+4px)]',
                        { 'opacity-1': paymentType === 'card' },
                      )}
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="1"
                        y="1"
                        width="20"
                        height="20"
                        rx="10"
                        stroke="#349760"
                        stroke-width="2"
                      />
                      <circle cx="11" cy="11" r="7" fill="#349760" />
                    </svg>
                  </span>
                  <span className="text-[16px] leading-[1.5] font-semibold block mr-1 text-[#101A36]">Credit card</span>

                  <img
                    className="block max-w-[42%] ml-auto"
                    src={props.paymentImage ?? '/img/logo-payments.png'}
                    alt="Logo payments"
                    width={145}
                    height={24}
                  />
                </button>

                <div className={cn('p-4 pt-0 hidden', { block: paymentType === 'card' })}>
                  <div className="flex font-semibold text-[#101A36 text-[14px] gap-2 mb-4 pt-5 border-t border-[#101A361A]">
                    Payment information
                    <p className="flex text-[#349760] items-center ml-auto gap-[3px]">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.25033 11C7.25033 11.4143 7.58612 11.75 8.00033 11.75C8.41455 11.75 8.75033 11.4143 8.75033 11H8.00033H7.25033ZM8.75033 9.66671C8.75033 9.25249 8.41455 8.91671 8.00033 8.91671C7.58612 8.91671 7.25033 9.25249 7.25033 9.66671H8.00033H8.75033ZM2.84553 12.5632L3.58883 12.4631L3.58882 12.4631L2.84553 12.5632ZM5.0401 14.6006L5.00565 15.3498L5.00567 15.3498L5.0401 14.6006ZM10.9605 14.6006L10.995 15.3498L10.995 15.3498L10.9605 14.6006ZM13.1551 12.5632L13.8984 12.6633L13.8984 12.6632L13.1551 12.5632ZM13.1551 8.10357L13.8984 8.00354L13.8984 8.00349L13.1551 8.10357ZM10.9605 6.0661L10.995 5.31689L10.995 5.31689L10.9605 6.0661ZM5.0401 6.0661L5.00566 5.31689L5.00565 5.31689L5.0401 6.0661ZM2.84553 8.10357L3.58882 8.20365L3.58883 8.20365L2.84553 8.10357ZM4.25033 6.00004C4.25033 6.41425 4.58612 6.75004 5.00033 6.75004C5.41455 6.75004 5.75033 6.41425 5.75033 6.00004H5.00033H4.25033ZM10.2503 6.00004C10.2503 6.41425 10.5861 6.75004 11.0003 6.75004C11.4145 6.75004 11.7503 6.41425 11.7503 6.00004H11.0003H10.2503ZM8.00033 11H8.75033V9.66671H8.00033H7.25033V11H8.00033ZM2.84553 12.5632L2.10224 12.6632C2.29885 14.1236 3.50878 15.281 5.00565 15.3498L5.0401 14.6006L5.07454 13.8514C4.32671 13.817 3.69206 13.2299 3.58883 12.4631L2.84553 12.5632ZM5.0401 14.6006L5.00567 15.3498C5.96187 15.3938 6.93271 15.4167 8.00033 15.4167V14.6667V13.9167C6.95502 13.9167 6.00714 13.8943 5.07453 13.8514L5.0401 14.6006ZM8.00033 14.6667V15.4167C9.06795 15.4167 10.0388 15.3938 10.995 15.3498L10.9605 14.6006L10.9261 13.8514C9.99349 13.8943 9.04565 13.9167 8.00033 13.9167V14.6667ZM10.9605 14.6006L10.995 15.3498C12.4919 15.281 13.7018 14.1236 13.8984 12.6633L13.1551 12.5632L12.4118 12.4631C12.3086 13.2299 11.674 13.817 10.9261 13.8514L10.9605 14.6006ZM13.1551 12.5632L13.8984 12.6632C13.9976 11.9263 14.0837 11.1423 14.0837 10.3334H13.3337H12.5837C12.5837 11.0412 12.5083 11.7467 12.4118 12.4631L13.1551 12.5632ZM13.3337 10.3334H14.0837C14.0837 9.52443 13.9976 8.74047 13.8984 8.00354L13.1551 8.10357L12.4118 8.20361C12.5083 8.92002 12.5837 9.62552 12.5837 10.3334H13.3337ZM13.1551 8.10357L13.8984 8.00349C13.7018 6.54319 12.4919 5.38571 10.995 5.31689L10.9605 6.0661L10.9261 6.81531C11.674 6.84969 12.3086 7.43689 12.4118 8.20366L13.1551 8.10357ZM10.9605 6.0661L10.995 5.31689C10.0388 5.27294 9.06794 5.25004 8.00033 5.25004V6.00004V6.75004C9.04566 6.75004 9.9935 6.77244 10.9261 6.81531L10.9605 6.0661ZM8.00033 6.00004V5.25004C6.93272 5.25004 5.96188 5.27294 5.00566 5.31689L5.0401 6.0661L5.07454 6.81531C6.00714 6.77244 6.95501 6.75004 8.00033 6.75004V6.00004ZM5.0401 6.0661L5.00565 5.31689C3.50877 5.38571 2.29885 6.54319 2.10224 8.0035L2.84553 8.10357L3.58883 8.20365C3.69206 7.43689 4.32672 6.84969 5.07454 6.81531L5.0401 6.0661ZM2.84553 8.10357L2.10224 8.0035C2.00301 8.74049 1.91699 9.52444 1.91699 10.3334H2.66699H3.41699C3.41699 9.62551 3.49238 8.91999 3.58882 8.20365L2.84553 8.10357ZM2.66699 10.3334H1.91699C1.91699 11.1423 2.00301 11.9263 2.10224 12.6633L2.84553 12.5632L3.58882 12.4631C3.49238 11.7468 3.41699 11.0412 3.41699 10.3334H2.66699ZM5.00033 6.00004H5.75033V4.33337H5.00033H4.25033V6.00004H5.00033ZM5.00033 4.33337H5.75033C5.75033 3.09073 6.75769 2.08337 8.00033 2.08337V1.33337V0.583374C5.92927 0.583374 4.25033 2.26231 4.25033 4.33337H5.00033ZM8.00033 1.33337V2.08337C9.24298 2.08337 10.2503 3.09073 10.2503 4.33337H11.0003H11.7503C11.7503 2.26231 10.0714 0.583374 8.00033 0.583374V1.33337ZM11.0003 4.33337H10.2503V6.00004H11.0003H11.7503V4.33337H11.0003Z"
                          fill="#349760"
                        />
                      </svg>
                      Protected
                    </p>
                  </div>

                  <Payment
                    applePayButtonParams={{
                      enabled: true,
                      color: theme === 'dark' ? 'white' : 'black',
                      type: 'pay',
                      integrationType: 'js',
                    }}
                    applePayContainerRef={appleContainerRef}
                    merchantData={merchantData}
                    styles={{
                      '.two-columns': {
                        gap: '12px !important',
                        margin: '12px 0',
                      },
                      submit_button: {
                        'margin-top': '24px',
                        'text-transform': 'capitalize',
                        background:
                          theme === 'dark'
                            ? 'linear-gradient(90deg, #FF2FDB 0%, #9829FF 25%, #293AFF 50%, #1F79FF 75%, #40E6FF 100%);'
                            : '#349760',
                        color: '#FFFFFF',
                        'font-weight': '600',
                        'font-size': '16px',
                        padding: '12px 16px',
                        'border-radius': '24px',
                        height: '48px',
                        '.title-icon': {
                          display: 'none',
                        },
                        ':disabled': {
                          opacity: '0.1',
                          cursor: 'not-allowed',
                        },
                      },
                      expiry_date: {
                        'margin-right': '-7px !important',
                        'margin-top': '-7.5px !important',
                      },
                      card_cvv: {
                        'margin-left': '-7px !important',
                        'margin-top': '-7.5px !important',
                      },
                      input_group: {
                        '.label': {
                          color: '#101A36B2',
                          'font-weight': '500',
                          'font-size': '12px',
                        },
                        '.brand-icon': {
                          top: '46px',
                        },
                        input: {
                          color: theme === 'dark' ? '#FBFBFB' : '#101A36',
                          background: theme === 'dark' ? '#1A1A1D' : '#101A360A',
                          'border-color': theme === 'dark' ? '#6E6E70' : 'transparent',
                          'font-weight': '500',
                          'font-size': '16px',
                          'border-radius': '24px',
                          height: '56px',
                          '::placeholder': {
                            color: '#101A3666',
                          'font-weight': '500',
                          'font-size': '16px',
                          },
                          ':focus': {
                            '::placeholder': {
                              color: '#101A3666',
                          'font-weight': '500',
                          'font-size': '16px',
                            },
                          },
                        },
                        '.not-empty .label': {
                          color: mainColor,
                        },
                        '.not-empty.error .label': {
                          color: '#DB2A30',
                        },
                        '.error input': {
                          'border-color': '#DB2A30',
                        },
                      },
                    }}
                    formParams={{
                      submitButtonText: 'Continue',
                    }}
                    onError={handleOnError}
                    onFail={handleOnFail}
                    onCard={handleCard}
                    onMounted={handleOnMounted}
                    onOrderStatus={handleOrderStatus}
                    onResize={handleOnResize}
                    onSuccess={handleOnSuccess}
                    onSubmit={handleOnSubmit}
                    onInteraction={handleOnInteraction}
                    onVerify={handleOnVerify}
                    onFormRedirect={handleOnRedirectMessage}
                    onCustomStylesAppended={handleOnCustomStylesAppended}
                    onReadyPaymentInstance={handleOnReadyPaymentInstance}
                  />
                </div>
              </div>

              {isFailedPayment && (
                <div className="relative top-[-50px]">
                  {paymentError && <p className="popup-description">{paymentError}</p>}
                  <div className=" popup-wr">
                    <div className="popup-inner">
                      <img
                        className="block mb-2"
                        src="/video/error.gif"
                        alt="Icon"
                        width={130}
                        height={130}
                      />
                      <h3 className="popup-title">
                        There was an error processing your payment information
                      </h3>

                      <button
                        className="text-center mt-6 w-full h-14 py-2.5 px-4 rounded-4xl text-[white] dark:text-black bg-buttonGradient disabled:bg-buttonDisable text-L font-bold"
                        onClick={() => setIsFailedPayment(false)}
                      >
                        Try again
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )
        : merchantData && (
            <div className={cn({ 'payment-response': isFailedPayment }, 'solid-gate-form mt-6')}>
              <div
                className={cn('border rounded-[16px] border-transparent', {
                  'bg-black border-[#3947E6]': paymentType === 'applePay',
                })}
              >
                <button
                  className={cn(
                    'flex min-h-[72px] font-medium text-[#8B8B8C] items-center rounded-[16px] w-full py-2 px-4 bg-bg dark:bg-[#323232]',
                    { 'bg-transparent dark:bg-transparent text-white': paymentType === 'applePay' },
                  )}
                  onClick={() => setPaymentType('applePay')}
                >
                  <span className="w-5 relative mr-4 min-w-5 block h-5 bg-black dark:bg-transparent rounded-full border-[#A9B2FF] border-2">
                    <svg
                      className={cn(
                        'absolute top-[-2px] left-[-2px] w-[calc(100%+4px)] opacity-0 h-[calc(100%+4px)]',
                        { 'opacity-1': paymentType === 'applePay' },
                      )}
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="11"
                        cy="11"
                        r="10"
                        fill="#3947E6"
                        stroke="#3947E6"
                        strokeWidth="2"
                      />
                      <path
                        d="M7.57886 11.1297L10.0778 13.6276L15.0736 8.63184"
                        stroke="#FBFBFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>

                  <span className="text-LXL block mr-1">One-click payment</span>

                  <span className="ml-auto block">
                    <svg
                      width="47"
                      height="24"
                      viewBox="0 0 47 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="47" height="24" rx="4" fill="#FBFBFB" />
                      <g clipPath="url(#clip0_817_3371)">
                        <path
                          d="M11.126 6.05521C10.669 6.59366 9.93762 7.01836 9.20628 6.95768C9.11487 6.22964 9.47292 5.45609 9.89191 4.97831C10.349 4.42469 11.1489 4.03034 11.7964 4C11.8726 4.75838 11.5755 5.50159 11.126 6.05521ZM11.7888 7.10178C10.7299 7.04111 9.82335 7.7009 9.32056 7.7009C8.81015 7.7009 8.04072 7.13211 7.20273 7.14728C6.11335 7.16245 5.10015 7.77674 4.54403 8.75505C3.40132 10.7117 4.24693 13.6087 5.35155 15.2013C5.89243 15.99 6.53996 16.8546 7.39319 16.8242C8.2007 16.7939 8.52066 16.3009 9.49577 16.3009C10.4785 16.3009 10.7604 16.8242 11.6136 16.8091C12.4973 16.7939 13.0534 16.0203 13.5943 15.2316C14.2114 14.3367 14.4627 13.4646 14.478 13.4191C14.4627 13.4039 12.7715 12.7593 12.7563 10.8178C12.7411 9.19491 14.0895 8.42136 14.1504 8.37586C13.3886 7.25345 12.2002 7.13211 11.7888 7.10178ZM17.9061 4.90247V16.7256H19.7497V12.6835H22.3017C24.6329 12.6835 26.2707 11.0909 26.2707 8.78538C26.2707 6.47991 24.6633 4.90247 22.3627 4.90247H17.9061ZM19.7497 6.44957H21.8751C23.4749 6.44957 24.3891 7.29896 24.3891 8.79297C24.3891 10.287 23.4749 11.1439 21.8675 11.1439H19.7497V6.44957ZM29.6379 16.8166C30.7959 16.8166 31.87 16.2327 32.3576 15.3075H32.3957V16.7256H34.1021V10.8406C34.1021 9.13424 32.7309 8.03459 30.6207 8.03459C28.6628 8.03459 27.2154 9.14941 27.1621 10.6813H28.8228C28.9599 9.95329 29.6379 9.47551 30.5673 9.47551C31.6948 9.47551 32.3271 9.99879 32.3271 10.9619V11.6141L30.0264 11.7507C27.8858 11.8796 26.7278 12.7517 26.7278 14.2685C26.7278 15.8004 27.9239 16.8166 29.6379 16.8166ZM30.1331 15.4136C29.1504 15.4136 28.5257 14.9434 28.5257 14.223C28.5257 13.4798 29.1275 13.0475 30.2778 12.9792L32.3271 12.8503V13.5177C32.3271 14.6249 31.3825 15.4136 30.1331 15.4136ZM36.3799 19.9412C38.1778 19.9412 39.0234 19.2586 39.7623 17.1882L43 8.14834H41.126L38.9548 15.133H38.9167L36.7456 8.14834H34.8182L37.9416 16.756L37.774 17.2792C37.4921 18.1666 37.0351 18.5078 36.2199 18.5078C36.0752 18.5078 35.7933 18.4927 35.679 18.4775V19.8957C35.7857 19.926 36.2428 19.9412 36.3799 19.9412Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_817_3371">
                          <rect width="39" height="16" fill="white" transform="translate(4 4)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </button>
                <div className={cn('p-4 pt-0 hidden', { block: paymentType === 'applePay' })}>
                  <div ref={appleContainerRef} className="h-[56px]" />
                </div>
              </div>

              <div
                className={cn('border mt-2 rounded-[16px] border-transparent', {
                  'bg-black border-[#3947E6]': paymentType === 'card',
                })}
              >
                <button
                  className={cn(
                    'flex min-h-[72px] font-medium text-[#8B8B8C] items-center rounded-[16px] w-full py-2 px-4 bg-bg dark:bg-[#323232]',
                    { 'bg-transparent dark:bg-transparent text-white': paymentType === 'card' },
                  )}
                  onClick={() => setPaymentType('card')}
                >
                  <span className="w-5 relative mr-4 min-w-5 block h-5 bg-black dark:bg-transparent rounded-full border-[#A9B2FF] border-2">
                    <svg
                      className={cn(
                        'absolute top-[-2px] left-[-2px] w-[calc(100%+4px)] opacity-0 h-[calc(100%+4px)]',
                        { 'opacity-1': paymentType === 'card' },
                      )}
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="11"
                        cy="11"
                        r="10"
                        fill="#3947E6"
                        stroke="#3947E6"
                        strokeWidth="2"
                      />
                      <path
                        d="M7.57886 11.1297L10.0778 13.6276L15.0736 8.63184"
                        stroke="#FBFBFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="text-LXL block mr-1">Credit card</span>

                  <img
                    className="block max-w-[42%] ml-auto"
                    src={props.paymentImage ?? '/img/logo-payments.png'}
                    alt="Logo payments"
                    width={145}
                    height={24}
                  />
                </button>

                <div className={cn('p-4 pt-0 hidden', { block: paymentType === 'card' })}>
                  <div className="flex font-medium gap-2 mb-4">
                    Payment information
                    <p className="flex text-[#8B8B8C] items-center ml-auto">
                      <svg
                        className="mr-1"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 13.7497V12.083"
                          stroke="#8B8B8C"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M3.55643 15.7039C3.74383 17.0958 4.89669 18.1862 6.29964 18.2507C7.48014 18.305 8.67934 18.3333 9.99993 18.3333C11.3205 18.3333 12.5197 18.305 13.7002 18.2507C15.1032 18.1862 16.256 17.0958 16.4434 15.7039C16.5657 14.7956 16.6666 13.8647 16.6666 12.9167C16.6666 11.9687 16.5657 11.0378 16.4434 10.1294C16.256 8.7375 15.1032 7.64707 13.7002 7.58257C12.5197 7.52831 11.3205 7.5 9.99993 7.5C8.67934 7.5 7.48014 7.52831 6.29964 7.58257C4.89669 7.64707 3.74383 8.7375 3.55643 10.1294C3.43413 11.0378 3.33325 11.9687 3.33325 12.9167C3.33325 13.8647 3.43413 14.7956 3.55643 15.7039Z"
                          stroke="#8B8B8C"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M6.25 7.50033V5.41699C6.25 3.34593 7.92893 1.66699 10 1.66699C12.0711 1.66699 13.75 3.34593 13.75 5.41699V7.50033"
                          stroke="#8B8B8C"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Protected
                    </p>
                  </div>

                  <Payment
                    applePayButtonParams={{
                      enabled: true,
                      color: theme === 'dark' ? 'white' : 'black',
                      type: 'pay',
                      integrationType: 'js',
                    }}
                    applePayContainerRef={appleContainerRef}
                    merchantData={merchantData}
                    styles={{
                      '.two-columns': {
                        gap: '8px !important',
                        margin: '8px 0',
                      },
                      submit_button: {
                        'margin-top': '16px',
                        'text-transform': 'capitalize',
                        background:
                          theme === 'dark'
                            ? 'linear-gradient(90deg, #FF2FDB 0%, #9829FF 25%, #293AFF 50%, #1F79FF 75%, #40E6FF 100%);'
                            : '#1D2BDB',
                        color: '#FBFBFB',
                        'font-weight': '700',
                        'font-size': '20px',
                        padding: '14px 16px',
                        'border-radius': '40px',
                        height: '56px',
                        '.title-icon': {
                          display: 'none',
                        },
                        ':disabled': {
                          opacity: '0.1',
                          cursor: 'not-allowed',
                        },
                      },
                      expiry_date: {
                        'margin-right': '-7px !important',
                        'margin-top': '-7.5px !important',
                      },
                      card_cvv: {
                        'margin-left': '-7px !important',
                        'margin-top': '-7.5px !important',
                      },
                      input_group: {
                        '.label': {
                          color: theme === 'dark' ? '#6E6E70' : '#8B8B8C',
                          'font-weight': '400',
                          'font-size': '14px',
                        },
                        '.brand-icon': {
                          top: '46px',
                        },
                        input: {
                          color: theme === 'dark' ? '#FBFBFB' : '#0E0E0F',
                          background: theme === 'dark' ? '#1A1A1D' : '#FBFBFB',
                          'border-color': theme === 'dark' ? '#6E6E70' : '#A9B2FF',
                          'font-weight': '400',
                          'font-size': '18px',
                          'border-radius': '16px',
                          height: '56px',
                          '::placeholder': {
                            color: theme === 'dark' ? '#6E6E70' : '#A9B2FF',
                          },
                          ':focus': {
                            '::placeholder': {
                              color: theme === 'dark' ? '#6E6E70' : '#A9B2FF',
                            },
                          },
                        },
                        '.not-empty .label': {
                          color: mainColor,
                        },
                        '.not-empty.error .label': {
                          color: '#DB2A30',
                        },
                        '.error input': {
                          'border-color': '#DB2A30',
                        },
                      },
                    }}
                    formParams={{
                      submitButtonText: 'Continue',
                    }}
                    onError={handleOnError}
                    onFail={handleOnFail}
                    onCard={handleCard}
                    onMounted={handleOnMounted}
                    onOrderStatus={handleOrderStatus}
                    onResize={handleOnResize}
                    onSuccess={handleOnSuccess}
                    onSubmit={handleOnSubmit}
                    onInteraction={handleOnInteraction}
                    onVerify={handleOnVerify}
                    onFormRedirect={handleOnRedirectMessage}
                    onCustomStylesAppended={handleOnCustomStylesAppended}
                    onReadyPaymentInstance={handleOnReadyPaymentInstance}
                  />
                </div>
              </div>

              {isFailedPayment && (
                <div className="relative top-[-50px]">
                  {paymentError && <p className="popup-description">{paymentError}</p>}
                  <div className=" popup-wr">
                    <div className="popup-inner">
                      <img
                        className="block mb-2"
                        src="/video/error.gif"
                        alt="Icon"
                        width={130}
                        height={130}
                      />
                      <h3 className="popup-title">
                        There was an error processing your payment information
                      </h3>

                      <button
                        className="text-center mt-6 w-full h-14 py-2.5 px-4 rounded-4xl text-white dark:text-black bg-buttonGradient disabled:bg-buttonDisable text-L font-bold"
                        onClick={() => setIsFailedPayment(false)}
                      >
                        Try again
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
    </>
  )
}
